// extracted by mini-css-extract-plugin
export default {"root":"TrainerStatusStrip_root__2CSTg","text":"TrainerStatusStrip_text__5fh5v","button":"TrainerStatusStrip_button__G4t2u"};